import React from 'react';
import { Alert, AlertTitle, Button, Stack, Typography } from '@mui/material';

export interface NextStepAction {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
  primary?: boolean;
}

interface SavedNextStepsProps {
  id?: string;
  title: string;
  message?: React.ReactNode;
  actions: NextStepAction[];
  onClose: () => void;
  sx?: object;
}

/** Inline confirmation after a save that points at the obvious next steps. */
export const SavedNextSteps: React.FC<SavedNextStepsProps> = ({ id, title, message, actions, onClose, sx }) => (
  <Alert id={id} severity="success" onClose={onClose} sx={{ scrollMarginTop: 96, ...sx }} role="status">
    <AlertTitle sx={{ fontWeight: 700 }}>{title}</AlertTitle>
    {message && (
      <Typography variant="body2" sx={{ mb: actions.length ? 1.5 : 0 }}>
        {message}
      </Typography>
    )}
    {actions.length > 0 && (
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {actions.map((a) => (
          <Button
            key={a.label}
            size="small"
            variant={a.primary ? 'contained' : 'outlined'}
            color={a.primary ? 'success' : 'inherit'}
            startIcon={a.icon}
            onClick={a.onClick}
          >
            {a.label}
          </Button>
        ))}
      </Stack>
    )}
  </Alert>
);

export default SavedNextSteps;
